/* Small, delegated pointer-reflection handler; compatible with Shopify section re-renders. */
(() => {
  if (window.__mzLiquidGlassInstalled) return;
  window.__mzLiquidGlassInstalled = true;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.mz-liquid-glass';
  let queued = false;
  let current = null;
  const lightAt = (button, event) => {
    const r = button.getBoundingClientRect();
    if (!r.width || !r.height) return;
    button.style.setProperty('--mz-reflection-x', ((event.clientX-r.left)/r.width*100)+'%');
    button.style.setProperty('--mz-reflection-y', ((event.clientY-r.top)/r.height*100)+'%');
  };
  document.addEventListener('pointermove', event => {
    if (!fine.matches || reduced.matches) return;
    const button = event.target.closest?.(selector);
    if (!button) return;
    current = {button,x:event.clientX,y:event.clientY};
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      if (current) lightAt(current.button,current);
    });
  }, {passive:true});
  document.addEventListener('pointerdown', event => {
    if (reduced.matches || event.button !== 0) return;
    const button = event.target.closest?.(selector);
    if (button) lightAt(button,event);
  }, {passive:true});
  document.addEventListener('pointerout', event => {
    const button = event.target.closest?.(selector);
    if (!button || (event.relatedTarget && button.contains(event.relatedTarget))) return;
    button.style.removeProperty('--mz-reflection-x');
    button.style.removeProperty('--mz-reflection-y');
    if (current?.button===button) current=null;
  }, {passive:true});
})();
